var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9889 3.05859L8.22741 5.36703C8.52213 5.67105 9.0075 5.6785 9.31149 5.3837C9.6155 5.08898 9.62295 4.60359 9.32816 4.29962L5.77262 0.632968C5.77261 0.632964 5.77261 0.632959 5.7726 0.632954C5.62825 0.484036 5.42963 0.4 5.22223 0.4C5.01483 0.4 4.81621 0.484041 4.67185 0.632968L1.11632 4.29961C1.11632 4.29962 1.11631 4.29962 1.11631 4.29962C0.821515 4.60358 0.828965 5.08898 1.13297 5.3837C1.43697 5.6785 1.92233 5.67105 2.21706 5.36703L4.45557 3.05859V11.8333C4.45557 12.2567 4.79883 12.6 5.22223 12.6C5.64564 12.6 5.9889 12.2567 5.9889 11.8333V3.05859Z",
    fill: "#98A2B3",
    stroke: "#98A2B3",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortArrow);
export default __webpack_public_path__ + "static/media/sortArrow.ca774e20bdcf8777726fc11d3d851e53.svg";
export { ForwardRef as ReactComponent };